import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Popover, PopoverPlacement, PopoverTrigger} from '../popover/popover';

@Component({
  template: require('./tooltip.html'),
  name: 'wc-tooltip',
  components: {
    'wc-popover': Popover
  }
})
export class Tooltip extends Vue {
  @Prop()
  placement: PopoverPlacement;

  @Prop()
  title: string;

  @Prop()
  trigger: PopoverTrigger;

  get popoverPlacement() {
    return this.placement || PopoverPlacement.Top;
  }

  get popoverTrigger() {
    return this.trigger || PopoverTrigger.Hover;
  }
}



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/tooltip/tooltip.ts